module.exports = __webpack_public_path__ + "img/4_x16.3315b872.png";